import { render, staticRenderFns } from "./LapPembelian.vue?vue&type=template&id=2c48709a"
import script from "./LapPembelian.vue?vue&type=script&lang=js"
export * from "./LapPembelian.vue?vue&type=script&lang=js"
import style0 from "./LapPembelian.vue?vue&type=style&index=0&id=2c48709a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports